/**
 * Group types. Apartments require a member ID (flat number); other types do not.
 */
export const GROUP_TYPES = {
  APARTMENT: 'apartment',
  CLUB: 'club',
  CUSTOM: 'custom'
};

export const GROUP_TYPE_LABELS = {
  [GROUP_TYPES.APARTMENT]: 'Apartment',
  [GROUP_TYPES.CLUB]: 'Club',
  [GROUP_TYPES.CUSTOM]: 'Custom'
};

/** Group types that require a member ID (e.g. flat number for apartment). */
export function groupTypeRequiresMemberId(type) {
  return type === GROUP_TYPES.APARTMENT;
}

/** Default for new groups: approval required (not open). */
export const DEFAULT_GROUP_IS_OPEN = false;

/**
 * Groups can be tied to one or more sports (gameIds). Empty or missing = group is for all sports.
 * Same group is used across sports; gameIds only filters which tournaments (per sport) can use this group.
 * @param {object} group - Group doc with optional gameIds: string[]
 * @param {string} gameId - Current sport/game id (e.g. 'table-tennis')
 * @returns {boolean} true if group applies to this sport
 */
export function groupMatchesGame(group, gameId) {
  if (!gameId) return true;
  const ids = group?.gameIds;
  if (!ids || !Array.isArray(ids) || ids.length === 0) return true;
  return ids.includes(gameId);
}
